module.exports = __webpack_public_path__ + "img/centro-comercial-cba.69580669.jpg";